import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface DocumentPreviewProps {
  url: string | null;
  onClose: () => void;
}

export const DocumentPreview = ({ url, onClose }: DocumentPreviewProps) => {
  if (!url) return null;

  return (
    <Dialog open={!!url} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>Document Preview</DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <iframe
            src={url}
            className="w-full h-[600px]"
            title="Document Preview"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};